import { useEffect, useState } from "react";
import Select from "react-select";



export default function PaginationSelect({page, setPage, getList, nbpage, current, setCurrent}) {
    // states
    const [listpage, setListpage] = useState([]);

    const getPages = () => {
        let list = [...listpage];
        for (let i = 0; i < nbpage; i++) {
            list.push({label: `Page ${i+1}`, value: i});
        }
        setListpage(list);
    }



    // comportements
    useEffect(() => {
        getPages();
    }, []);


    // affichage
    return (
        <>
            {nbpage > 1 && <div>
                {/* <p className="mb-1">Pagination</p> */}
                <div className="row">
                    <div className="col-md-12">
                        {/* <label htmlFor="pages" className="mb-1">Select page</label> */}
                        <Select
                            id="pages"
                            name="pages"
                            options={listpage}
                            value={current}
                            onChange={(selected) => {
                                setCurrent(selected); 
                                setPage(selected["value"]);
                                getList(selected["value"]);
                            }}
                            placeholder="Pagination"
                        />
                    </div>
                </div>
            </div>}
        </>
    )
}